export default class File {
    constructor(file) {
        if (!file) {
            throw new Error('Invalid file passed.');
        }

        this.file = file;
    }

    get name() {
        return this.file.name;
    }

    get type() {
        return this.file.type;
    }

    get size() {
        return this.file.size;
    }

    media() {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.readAsDataURL(this.file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }

    async payload() {
        const data = await this.media();

        return {
            name: this.name,
            type: this.type,
            size: this.size,
            data,
        };
    }
}
